import { Component, Input } from "@angular/core";

@Component({
    selector: "app-funding-item-adjustments-table-cell-content",
    templateUrl: "./funding-item-adjustments-table-cell-content.component.html",
    styleUrls: ["./funding-item-adjustments-table-cell-content.component.less"],
    standalone: false
})
export class FundingItemAdjustmentsTableCellContentComponent {

    @Input() columnId: string;
    @Input() element: any;

}
